import { SxProps, Theme } from '@mui/material';
import { getMaskedIconStyle } from '../../../services/Utilities';

/**
 * Styles for ExportMenuComponent
 * Uses theme values from MuiProvider for consistent styling
 */

export const exportMenuClassNames = {
  moreIcon: 'export-menu-more-icon',
};

export const exportMenuStyles = {
  moreIcon: () => ({
    display: 'block',
    width: '24px',
    height: '24px',
    backgroundColor: 'currentColor',
    mask: 'var(--export-menu-icon-url) center / contain no-repeat',
    WebkitMask: 'var(--export-menu-icon-url) center / contain no-repeat',
  }) as SxProps<Theme>,

  link: (theme: Theme) => ({
    cursor: 'pointer',
    fontSize: theme.typography.body1.fontSize,
  }) as SxProps<Theme>,

  menuItem: (theme: Theme) => ({
    fontSize: theme.typography.body1.fontSize,
  }) as SxProps<Theme>,
};

export function getExportMenuIconStyle(src: string) {
  return getMaskedIconStyle('--export-menu-icon-url', src);
}

export default exportMenuStyles;
